import React, { useEffect } from "react";

import { setToastRef } from "./toast";
import { ToastProvider, useToastContext } from "./ToastContext";
import { ToastOptions, ToastVariant } from "./types";

const ToastInitializer = () => {
  const { notify } = useToastContext();

  useEffect(() => {
    const createToastFn =
      (variant: ToastVariant) =>
      (message: React.ReactNode, options?: ToastOptions) =>
        notify(message, variant, { ...options });

    setToastRef({
      success: createToastFn("success"),
      info: createToastFn("info"),
      warning: createToastFn("warning"),
      error: createToastFn("error"),
    });
  }, [notify]);

  return null;
};

export const ToastContainer = ({ children }: { children: React.ReactNode }) => (
  <ToastProvider>
    <ToastInitializer />
    {children}
  </ToastProvider>
);
